// extracted by mini-css-extract-plugin
module.exports = {"base":"base-9a6863","media":"media-9a6863","link":"link-9a6863","title":"title-9a6863","text":"text-9a6863"};